import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { LanguageProvider } from "../../../core/language-provider";

const VersionCheck = () => {
    const [showModal, setShowModal] = useState(false);
    const [newVersion, setNewVersion] = useState(null);

    useEffect(() => {
        // Initial check
        checkVersion();

        // Set interval for periodic checks (every 15 minutes)
        const intervalId = setInterval(() => {
            checkVersion();
        }, 15 * 60 * 1000); // 15 minutes in milliseconds

        // Cleanup interval on unmount
        return () => clearInterval(intervalId);
    }, []);

    const checkVersion = async () => {
        try {
            // Fetch version.json with cache busting
            const response = await fetch(`/version.json?t=${Date.now()}`);
            const data = await response.json();
            const serverVersion = data.version;

            // Get stored version from localStorage
            const storedVersion = localStorage.getItem("app_version");

            // If no stored version, save current version
            if (!storedVersion) {
                localStorage.setItem("app_version", serverVersion);
                return;
            }

            // If versions don't match, show modal
            if (storedVersion !== serverVersion) {
                setNewVersion(serverVersion);
                setShowModal(true);
            }
        } catch (error) {
            console.warn("Error checking version:", error);
        }
    };

    const handleRefresh = () => {
        // Save new version to localStorage
        if (newVersion) {
            localStorage.setItem("app_version", newVersion);
        }

        window.location.reload();
    };

    return (
        <Dialog
            visible={showModal}
            onHide={() => {}}
            className="w-full max-w-md"
            draggable={false}
            closable={false}
            dismissableMask={false}
            pt={{
                root: {
                    className: "m-4",
                },
                header: {
                    className: "hidden",
                },
                content: {
                    className: "p-6 sm:p-8 rounded-2xl scrollbar-hide",
                },
            }}
        >
            <div className="text-black">
                <h1 className="text--h2 uppercase">
                    {LanguageProvider.get(
                        "version.update_available",
                        "Aggiornamento Disponibile",
                    )}
                </h1>
                <p className="mt-4">
                    {LanguageProvider.get(
                        "version.update_message",
                        "È disponibile una nuova versione dell'applicazione. Per utilizzare le nuove funzionalità è necessario ricaricare la pagina.",
                    )}
                </p>
                {newVersion && (
                    <p className="mt-2 text-sm text-gray">
                        <small>
                            {LanguageProvider.get(
                                "version.new_version",
                                "Nuova versione",
                            )}
                            : <strong>{newVersion}</strong>
                        </small>
                    </p>
                )}
                <div className="mt-6 flex justify-end">
                    <button
                        className="btn--secondary text--h2 uppercase"
                        onClick={handleRefresh}
                    >
                        {LanguageProvider.get(
                            "version.reload_now",
                            "Ricarica Ora",
                        )}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default VersionCheck;
